import React from 'react';
import { HospitalityOrdersPageView } from '@features/whereabouts/pages/hospitality/HospitalityOrdersPageView';

export function HospitalityOrdersPage(props: Props) {
  return (
    <HospitalityOrdersPageView />
  )
}

interface Props {

}
